import { memo, useCallback, useState, useEffect } from "react";

import { AccordionItemView } from "@components/AccordionItem/AccordionItem.view";
import { type AccordionItemBlock } from "@react/components/Accordion/Accordion.view";
import { type TTailwindString } from "classnames";

type Props = {
  className?: TTailwindString | undefined;
  content: AccordionItemBlock["content"];
  heading: string;
  isOpen?: boolean;
  itemIndex?: number | undefined;
  onToggle?: (index: number) => void | undefined;
};

const AccordionItemBase = ({
  content,
  isOpen = false,
  itemIndex = undefined,
  onToggle = undefined,
  ...props
}: Props) => {
  const [isInternallyOpen, setIsInternallyOpen] = useState<boolean>(isOpen);

  const toggleHandler = useCallback(() => {
    if (onToggle && itemIndex !== undefined) {
      onToggle(itemIndex);
    } else {
      setIsInternallyOpen(!isInternallyOpen);
    }
  }, [isInternallyOpen, itemIndex, onToggle]);

  useEffect(() => setIsInternallyOpen(isOpen), [isOpen]);

  return (
    <AccordionItemView
      content={content}
      isOpen={isInternallyOpen}
      onClick={toggleHandler}
      {...props}
    />
  );
};

export const AccordionItem = memo(AccordionItemBase);
